import React from 'react';
import { ReactComponent as LockupColour } from '@/assets/motorplan-logo/lockup-colour.svg?react';
import { ReactComponent as LockupReverse } from '@/assets/motorplan-logo/lockup-reverse.svg?react';
import { ReactComponent as Mark } from '@/assets/motorplan-logo/mark.svg?react';

interface MotorPlanLogoProps {
    className?: string;
    showText?: boolean;
    variant?: 'auto' | 'colour' | 'reverse';
    /**
     * Tailwind sizing class for the standalone mark. Only applied when `showText`
     * is false (mark-only render); ignored for the full lockup, which is sized via
     * `textSize`. May be a height (`h-8`) or width (`w-40`) class — the SVG viewBox
     * supplies the aspect ratio, so the unspecified axis is derived automatically.
     */
    iconSize?: string;
    /**
     * Tailwind sizing class for the full lockup. May be a height (`h-8`) or width
     * (`w-full`) class; the other axis is derived from the lockup's 7.18:1 viewBox.
     * The wide lockup is usually easier to size by width.
     */
    textSize?: string;
}

const MotorPlanLogo: React.FC<MotorPlanLogoProps> = ({
    className,
    showText = true,
    variant = 'auto',
    iconSize = 'h-8',
    textSize = 'h-8',
}) => {
    if (!showText) {
        return (
            <div className={className}>
                <Mark className={iconSize} />
            </div>
        );
    }

    if (variant === 'colour') {
        return (
            <div className={className}>
                <LockupColour className={textSize} />
            </div>
        );
    }

    if (variant === 'reverse') {
        return (
            <div className={className}>
                <LockupReverse className={textSize} />
            </div>
        );
    }

    // auto: colour on light, reverse on dark
    return (
        <div className={className}>
            <LockupColour className={`${textSize} block dark:hidden`} />
            <LockupReverse className={`${textSize} hidden dark:block`} />
        </div>
    );
};

export default MotorPlanLogo;
